import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          © 2025 LoyaltyHub CSC309 Project
        </p>
      </div>
    </footer>
  );
}
